import React from "react";
import { Dialog, Slide } from "@material-ui/core";
import TravelCardsFilterSection from "./TravelCardsFilterSection";
import { useSelector } from "react-redux";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export default (props) => {
  const { open, setOpen } = props.openObj;

  let { state: searchState } = useSelector((state) => ({
    state: state.search,
  }));

  let { state: resState } = useSelector((state) => ({
    state: state.reserve,
  }));

  return (
    <Dialog
      open={open}
      fullScreen
      TransitionComponent={Transition}
      PaperProps={{
        className: "filter-dialog",
      }}
    >
      <div
        className="row align-items-center py-5 px-7 filtered-modal-info"
        style={{ borderBottom: "1px solid lightgray" }}
      >
        <i
          className="fa fa-arrow-right filter-modal-close text-dark"
          onClick={() => {
            setOpen(false);
          }}
        ></i>
        <div className="d-flex flex-column">
          <h3>فیلترها</h3>
          <h6 className="light-txt">
            نمایش {resState.mockTravels.length} از {searchState.results.length}{" "}
            اتوبوس
          </h6>
        </div>
      </div>
      <TravelCardsFilterSection />
    </Dialog>
  );
};
